import { useState } from "react";
import { Avatar, Menu, MenuItem } from "@mui/material";
import { useContext } from "react";
import { RolesContext } from "../context/User";
import axios from "axios";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { MainContext } from "../context/OpenInvoice";

export default function LogOut({ showProfil }) {
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const [state, dispatch] = useContext(MainContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      const response = await axios.get(`/log_out`);
      if (response.status == 200) {
        dispatchroles({
          type: "USER",
          payload: {
            value: {
              customers: [],
              roles: [],
            },
          },
        });
        dispatch({
          type: "DATA_RESPONSE",
          payload: {
            value: [],
          },
        });

        navigate("/");
      }
    } catch (error) {
      if (error.response.status == 403) {
        navigate("/");
      }
    }
  };

  return (
    <div>
      {showProfil ? (
        <MenuItem onClick={handleLogout}>
          <LogoutIcon />
          &nbsp; יציאה
        </MenuItem>
      ) : (
        <>
          {" "}
          <Avatar
            sx={{ width: 50, height: 50 }}
            alt="first_letter_of_name"
            onClick={handleMenuOpen}
          >
            {stateroles.name ? stateroles.name.charAt(0) : ""}
          </Avatar>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleLogout}>
              <LogoutIcon />
              &nbsp; יציאה
            </MenuItem>
          </Menu>
        </>
      )}
    </div>
  );
}
